import { useMemo, useState } from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import CustomTable, { CustomTableVariants } from '@/DesignSystem/components/custom-table';
import { getJugadoresMercadoTableColumns } from './JugadoresMercadoTableColumns';
import { toPriceInEuros } from '@/helpers/prices-helper';
import { formatDateToDDMMYYYY } from '@/helpers/datetime-helper';
import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';

const JugadoresMercadoTableComponent = ({ player }) => {
    if (!player?.marketValues?.length) return null;

    const theme = useTheme();
    const [filter, setFilter] = useState('8 días');

    const columns = useMemo(() => {
        return getJugadoresMercadoTableColumns(theme);
    }, [theme]);

    // Filtra los valores de mercado según la opción seleccionada
    const filteredMarketValues = useMemo(() => {
        let marketValues = [...player.marketValues].sort((a, b) => b.day - a.day);
        marketValues = filter === '8 días'
            ? marketValues.slice(0, 8)
            : filter === '15 días'
                ? marketValues.slice(0, 15)
                : marketValues;

        return marketValues.map((item) => {
            const valorAnterior = marketValues.find((x) => x.day === item.day - 1)?.marketValue || 0;
            const subida = valorAnterior > 0 ? item.marketValue - valorAnterior : 0;
            return ({
                ...item,
                created: item.created ? formatDateToDDMMYYYY(item.created) : '',
                marketValue: toPriceInEuros(item.marketValue),
                subida,
            })
        });
    }, [filter, player.marketValues]);

    return (
        <CustomSectionWrapper title="Subidas y bajadas de mercado (Tabla)" color="accent2">
            {/* Botones para seleccionar el rango */}
            <Box sx={{ display: 'flex', gap: '10px' }} mt={1} mb={1}>
                {['8 días', '15 días', '30 días'].map((option) => (
                    <Button
                        key={option}
                        variant={filter === option ? 'contained' : 'outlined'}
                        color="primary"
                        onClick={() => setFilter(option)}
                        sx={{height: '30px', padding: '0 10px'}}
                    >
                        <Typography fontSize={14} component="span" color={filter === option ? 'white' : 'primary'}>
                            {option}
                        </Typography>
                    </Button>
                ))}
            </Box>
            <CustomTable
                columns={columns}
                rows={filteredMarketValues}
                rowHeight={30}
                variant={CustomTableVariants.WITHOUT_PAGINATION}
            />
        </CustomSectionWrapper>
    );
};

export default JugadoresMercadoTableComponent;
